import { createContext } from 'react';

const useMasterlistContext = createContext();
export default useMasterlistContext;
